import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators,Dispatch } from "redux";
import { 
  createEmptyEventEnum,
  createEmptyEventType,
  setEventTypeExtraProperties
} from "../../../utils/pdApiUtils";
import { EditActions, editActions } from "../../../actions/editActions";
import DoorEnumTable from "../../common/EnumTable/DoorEnumTable";
import EditDoorEventType from "../../Editing/EditDoorEventType";
import ActionMenu from "../../common/ActionMenu/ActionMenu";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../../components/NavigationLink/NavigationLink";
import ContentLayout from "../../../components/ContentLayout/ContentLayout";
import { parseUrlToName, parseNameToUrl } from "../../../utils/utils";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
type StateProps = {
  pdApi: State.PdApi;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  editActions: typeof editActions;
};
type OwnProps = {
  toggleModal: () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  match: any;
};
// Props of the component
export type DoorEventEnumsProps = StateProps & DispatchProps & OwnProps & {
  objectIdentifier: string;
};

type DoorEventEnumsState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeMenu: State.DoorEventEnumsSubmenu;
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.DoorEventEnumsSubmenu]: Filter[];
  };
};

export class DoorEventEnumerations extends React.Component<
  DoorEventEnumsProps,
  DoorEventEnumsState
> {
  subMenus: State.DoorEventEnumsSubmenu[] = [
    "Door Event Classes",
    "Door Event Types",
    "Door Event Pids",
    "Door Ext. Commands"
  ];

  subPages: Internal.DoorEnumSubPages = {
    "Door Event Classes": {
      itemName: "event class",//AddEventClass button in UI is this only.
      PdApiField: "doorEventClasses",
      dataView: DoorEnumTable,
      createEmpty: createEmptyEventEnum,
      setExtraProperties: null
    },
    "Door Event Types": {
      itemName: "event type",
      PdApiField: "doorEventTypes",
      dataView: DoorEnumTable,
      createEmpty: createEmptyEventType,
      setExtraProperties: setEventTypeExtraProperties,
      editor: EditDoorEventType
    },
    "Door Event Pids": {
      itemName: "event pid",
      PdApiField: "doorEventPids",
      dataView: DoorEnumTable,
      createEmpty: createEmptyEventEnum,
      setExtraProperties: null
    },
    "Door Ext. Commands": {
      itemName: "command",
      PdApiField: "doorExtCommands",
      dataView: DoorEnumTable,
      createEmpty: createEmptyEventEnum,
      setExtraProperties: null
    }
  };

  state = {
    activeMenu: this.props.match.params.activeMenu
      ? parseUrlToName(this.props.match.params.activeMenu) as State.DoorEventEnumsSubmenu
      : "Door Event Classes",
    isModalOpen: false,
    tableColumnFilters: {
      "Door Event Classes": [],
      "Door Event Types": [],
      "Door Event Pids": [],
      "Door Ext. Commands": []
    }
  };
  componentDidUpdate(): void {
    const parseActiveMenuFromURL = this.props.match.params.activeMenu
      ? parseUrlToName(this.props.match.params.activeMenu) as State.DoorEventEnumsSubmenu
      : "Door Event Classes";
    if (this.state.activeMenu !== parseActiveMenuFromURL) {
      this.setState({ activeMenu: parseActiveMenuFromURL });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private setColumnFilters = (subMenuRoute: State.DoorEventEnumsSubmenu, newFilters: Filter[]): any => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  render(): JSX.Element {
    const { activeMenu } = this.state;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const links = Object.keys(this.subPages).map((name: any) => (
      <NavigationLink
        key={name}
        to={"/door/event-enumerations/" + parseNameToUrl(name)}
        name={name}
        title={name.toString().replace(/^Door\s*/, "")}
      />
    ));
    const actionMenu = (
      <ActionMenu
        {...this.props}
        subMenuRoute={activeMenu}
        itemName={this.subPages[activeMenu].itemName}
        selectedColumnsName={activeMenu}
        dataFieldName={this.subPages[activeMenu].PdApiField}
        setExtraProperties={this.subPages[activeMenu].setExtraProperties}
        createEmpty={this.subPages[activeMenu].createEmpty}
        groupName="Door"
        columnFilters={this.state.tableColumnFilters[activeMenu]}
        filterOptions={this.props.filterOptions}
      />
    );

    const dataView = (
      <DoorEnumTable
        subMenuRoute={activeMenu}
        toggleModal={this.toggleModal}
        dataFieldName={this.subPages[activeMenu].PdApiField}
        setColumnFilters={this.setColumnFilters}
        />
    );
    return (
      <>
        <ContentLayout submenu={links} actionMenu={actionMenu} dataView={dataView} />
        {this.buildModal()}
      </>
    );
  }
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };

  private buildModal = () => {
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.state.activeMenu].itemName}?
        <br />
        {this.props.objectIdentifier}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() =>
          this.props.editActions.delete(
            this.subPages[this.state.activeMenu].PdApiField as Api.OptionsGrud
          )
        }
        onCancel={this.toggleModal}
      />
    );
  };
}

const mapStateToProps = (state: State.Root) => ({
  pdApi: state.pdApi,
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DoorEventEnumerations);
